import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the offline / repeat-visit accelerator. Cache-first for images,
// fonts and CRA build assets — network-only for API JSON and HTML. See
// /public/sw.js. Only runs when served over HTTPS or on localhost.
if ("serviceWorker" in navigator && (window.location.protocol === "https:" || window.location.hostname === "localhost")) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("[sw] registration failed:", err));
  });

  // When a NEW service worker takes control (fresh deploy detected), force
  // a one-time reload so the current tab starts using the fresh JS bundle
  // immediately. Without this, users on mobile could keep seeing the OLD
  // cached bundle until they manually pull-to-refresh. `hasController`
  // gate prevents reloading on the very first SW install of a new visitor.
  let hasController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (hasController) window.location.reload();
    hasController = true;
  });
}
